import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import React, { useState } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import { IconButton, Stack, TextField, Typography } from "@mui/material";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper";
import { Delete } from "@mui/icons-material";
import Button from "../../../components/CustomButtons/Button";
import _ from "lodash";
import { VestigingFormContext } from "../../Vestigingen/VestigingForm";
import { ProductAttributes } from "../../../../../Domains/Products/api/productJsonApi.ts";
import { GET_PRODUCTS } from "../../../../../Domains/Products/api/productGraphQLApi.ts";
import { RenderOption } from "../../OptionGroups/Tabs/AutocompleteProductRenderOption.tsx";
import { AutocompleteCategory, AutocompleteProduct } from "@jamezz/react-components";
import { GET_PRODUCT_GROUPS } from "../../../../../Domains/ProductGroups/productGraphQLApi.ts";

export default function XPerGroupForY() {
  const { control, menukaartVestigingId, setValue, getValues, trigger, register }: VestigingFormContext =
    useFormContext<VestigingFormContext>();
  register("x_per_group_for_y");
  const { fields, append, prepend, remove, swap, move, insert, update } = useFieldArray<{
    name: string;
    numberOfProducts: number;
    productIds: number[];
    productGroupIds: number[];
  }>({
    control,
    name: "x_per_group_for_y",
  });

  return (
    <Card>
      <CardBody style={{ padding: 16 }}>
        <Stack gap={4}>
          <TranslationWrapper tKey={"Groups"} />

          {fields.map((field, index) => {
            return (
              <Stack direction={"row"} gap={4}>
                <Typography>{field.name}</Typography>
                <TextField
                  label={"Number of products"}
                  onChange={(e) => {
                    const copy = { ...getValues("x_per_group_for_y")[index], id: field.id };
                    copy.numberOfProducts = Number(e.target.value);
                    update(index, copy);
                  }}
                  value={field.numberOfProducts}
                />

                <AutocompleteProduct<true, ProductAttributes, true>
                  multiple
                  value={field.productIds?.map((field) => Number(field)) ?? []}
                  fetchQuery={GET_PRODUCTS}
                  menuSalesareaId={menukaartVestigingId}
                  inputFieldProps={{ sx: { minWidth: 300 } }}
                  onChange={(option) => {
                    setValue(`x_per_group_for_y.${index}.productIds`, _.chain(option).groupBy("id").keys().value());
                    const copy = { ...getValues("x_per_group_for_y")[index], id: field.id };
                    copy.productIds = _.chain(option).groupBy("id").keys().value();
                    update(index, copy);
                  }}
                  renderOption={(props, option) => <RenderOption option={option} />}
                />

                <AutocompleteCategory<true, { id: number; naam: string }, true>
                  multiple
                  value={field.productGroupIds?.map((field) => Number(field)) ?? []}
                  fetchQuery={GET_PRODUCT_GROUPS}
                  menuSalesareaId={menukaartVestigingId}
                  inputFieldProps={{ sx: { minWidth: 300 } }}
                  onChange={(option) => {
                    setValue(
                      `x_per_group_for_y.${index}.productGroupIds`,
                      _.chain(option).groupBy("id").keys().value()
                    );
                    const copy = { ...getValues("x_per_group_for_y")[index], id: field.id };
                    copy.productGroupIds = _.chain(option).groupBy("id").keys().value();
                    update(index, copy);
                  }}
                />

                <IconButton
                  onClick={() => {
                    remove(index);
                  }}
                >
                  <Delete />
                </IconButton>
              </Stack>
            );
          })}
        </Stack>

        <AddGroup append={append} />
      </CardBody>
    </Card>
  );
}

function AddGroup({ append }) {
  const [value, setValue] = useState("");
  return (
    <Stack alignItems={"center"} direction={"row"} gap={2}>
      <TextField onChange={(e) => setValue(e.target.value)} placeholder={"Group name"} value={value} />
      <Button
        disabled={!value}
        onClick={() => {
          setValue("");
          append({ name: value, productIds: [], numberOfProducts: 1 });
        }}
      >
        <TranslationWrapper tKey={"Add group"} />
      </Button>
    </Stack>
  );
}
